var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.15,
    y: -269.45,
    width: 37,
    height: 37
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.52,21.34c0-2.89,0-5.78,0-8.67,0-1.08-.37-1.46-1.44-1.46-3.68,0-7.35,0-11.03,0-1.03,0-1.42.39-1.42,1.43,0,5.81,0,11.61,0,17.42,0,1.06.38,1.44,1.46,1.44,3.66,0,7.32,0,10.99,0,1.06,0,1.44-.39,1.44-1.46,0-2.9,0-5.81,0-8.71ZM22.58,9.3c0-.94,0-1.83,0-2.71,0-.96-.37-1.32-1.33-1.32-3.72,0-7.44,0-11.17,0-1.01,0-1.4.39-1.4,1.4,0,5.74,0,11.47,0,17.21,0,.18,0,.35,0,.53.04.58.46,1.11,1.03,1.13,1.01.05,2.03.01,3.09.01v-.55c0-4.8,0-9.6,0-14.41,0-.96.32-1.3,1.28-1.3,2.39,0,4.79,0,7.18,0,.41,0,.82,0,1.3,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d2743dbb0e428ad44bba008fe94bb244.svg";
export { ForwardRef as ReactComponent };